export const headerVariants = {
    expanded: {
        height: 'auto',
    },
    collapsed: {
        height: '60px',
    },
};
